import { Routes } from "@angular/router";
import { LoginComponent } from "./body/login/login.component";
import { DemoPageComponent } from "./guest/demo-page/demo-page.component";
import { MyCarComponent } from "./guest/my-car/my-car.component";
import { PaymentFailedComponent } from "./guest/payment-failed/payment-failed.component";
import { PaymentSuccessComponent } from "./guest/payment-success/payment-success.component";
import { TermsConditionsComponent } from "./guest/terms-conditions/terms-conditions.component";
import { bodyRoutes } from "./body/body.routes";

export const routes: Routes = [
  { path: "", redirectTo: "user/home", pathMatch: "full" },
  { path: "auth", redirectTo: "auth/login" },
  {
    path: "auth",
    children: [{ path: "login", component: LoginComponent }],
  },
  { path: "valet-guest/:id", component: DemoPageComponent },
  { path: "valet-car/:id", component: MyCarComponent },
  { path: "valet-payment-success/:id", component: PaymentSuccessComponent },
  { path: "valet-payment-failed/:id", component: PaymentFailedComponent },
  { path: "terms-conditions/:id", component: TermsConditionsComponent },
  ...bodyRoutes,
  { path: "**", redirectTo: "auth/login" },
];